(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[268],{

/***/ 7895:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[id]",
      function () {
        return __webpack_require__(8291);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Card_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7539);
/* harmony import */ var _Card_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Card_module_css__WEBPACK_IMPORTED_MODULE_2__);



var BlogCard = function(param) {
    var blog = param.blog, _transformation = param.transformation, transformation = _transformation === void 0 ? false : _transformation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "col-6 col-lg-4 mb-4 p-md-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/blogs/" + blog.slug,
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: transformation && blog.transformation_image ? blog.transformation_image : blog.headerImage[0].image,
                        className: "w-100 ".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().cursorPointer)),
                        alt: blog.title
                    })
                })
            }),
            !transformation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/blogs/" + blog.slug,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().listed_blog_title), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fo20), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fw600), " text-center ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().mfo13), " mb-3"),
                                children: blog.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().listed_blog_summary), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fo14), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fw400), " text-center ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().mfo11)),
                        children: blog.summary
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _loaders_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5876);
/* harmony import */ var _loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_loaders_module_css__WEBPACK_IMPORTED_MODULE_1__);


var SimpleLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default().simpleLoader),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default().loader)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleLoader);


/***/ }),

/***/ 8291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var index_es = __webpack_require__(1417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(7814);
// EXTERNAL MODULE: ./components/blog/Section.module.css
var Section_module = __webpack_require__(1530);
var Section_module_default = /*#__PURE__*/__webpack_require__.n(Section_module);
;// CONCATENATED MODULE: ./components/blog/BlogShareIcons.jsx




var BlogShareIcons = function(param) {
    var postTitle = param.postTitle, postUrl = param.postUrl, postSummary = param.postSummary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-sm-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sticky blogShareIcons",
            id: "sticky",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-block d-sm-none text-center fo-20 fw-700 mt-5",
                    children: "Share this inspiring story!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "shareBorder d-block d-sm-none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row d-flex d-sm-block mt-5 mt-sm-0",
                    id: "shareBlog",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-1 d-block d-sm-none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 text-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Section_module_default()).blogShareDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.facebook.com/sharer.php?u=".concat(postUrl),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                        icon: index_es/* faFacebook */.neY
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 text-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Section_module_default()).blogShareDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://telegram.me/share/url?url=".concat(postUrl),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                        icon: index_es/* faTelegram */.Uv8
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 text-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Section_module_default()).blogShareDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.linkedin.com/shareArticle?mini=true&url=".concat(postUrl, "/&source=").concat(postUrl),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                        icon: index_es/* faLinkedinIn */.hwn
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 text-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Section_module_default()).blogShareDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://twitter.com/intent/tweet?text=".concat(postSummary, " ").concat(postUrl),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                        icon: index_es/* faTwitter */.mdU
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 text-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Section_module_default()).blogShareDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://api.whatsapp.com/send?text=".concat(postUrl, " - ").concat(postSummary),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                        icon: index_es/* faWhatsapp */.VHX
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-1 d-block d-sm-none"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var blog_BlogShareIcons = (BlogShareIcons);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
;// CONCATENATED MODULE: ./components/blog/BlogGallery.jsx



/* eslint-disable jsx-a11y/alt-text */ 
var BlogGallery = function(param) {
    var children = param.children;
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: true,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-12 col-sm-12 p-10 m-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: children
        }))
    });
};
/* harmony default export */ var blog_BlogGallery = (BlogGallery);
var SampleNextArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        className: "fas fa-long-arrow-alt-right",
        onClick: onClick,
        style: {
            bottom: "-15px",
            position: "absolute",
            right: "47%",
            fontSize: "26px"
        }
    });
};
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fas fa-long-arrow-alt-left",
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            bottom: "-15px",
            position: "absolute",
            right: "53%",
            fontSize: "26px"
        }),
        onClick: onClick
    });
}

;// CONCATENATED MODULE: ./components/blog/CoachSection.jsx


var CoachSection = function(param) {
    var coaches = param.coaches;
    var pStyle = coaches.length === 1 ? "p500" : coaches.length === 2 ? "p300" : "p150";
    var colDivision = 12 / coaches.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "coaches",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row m-0 ".concat(pStyle, " mt-3"),
            children: coaches && coaches.map(function(elem, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-".concat(colDivision, " col-sm-").concat(colDivision, " p-0"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: elem["image"],
                            alt: "".concat(elem["name"])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 ".concat((Section_module_default()).fw700, " ").concat((Section_module_default()).mfo11, " ").concat((Section_module_default()).ls9),
                            children: elem["designation"] === "" ? "".concat(elem["name"]) : "".concat(elem["designation"], " : ").concat(elem["name"])
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var blog_CoachSection = (CoachSection);

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(1436);
;// CONCATENATED MODULE: ./components/blog/Accordian.jsx





var Accordian = function(param) {
    var title = param.title, children = param.children;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var closeHandler = function() {
        return setIsActive(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Section_module_default()).accordian,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Section_module_default()).accordianTitle,
                onClick: function() {
                    return setIsActive(!isActive);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row m-0 p-2 pt-3 cursorPointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-10 col-sm-10 p-0 fo-18 fw-700 mfo-22 ps-xs-0 ps-lg-0",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-2 col-sm-2 text-center p-0 m-auto",
                                style: {
                                    transition: "transform .5s",
                                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons_index_es/* faChevronDown */.ptq,
                                    className: "".concat((Section_module_default()).bco, " ").concat((Section_module_default()).fo24)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: (Section_module_default()).horizontalBar
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).accordionContent,
                "aria-expanded": isActive,
                onClick: closeHandler,
                children: children
            })
        ]
    });
};
/* harmony default export */ var blog_Accordian = (Accordian);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 7 modules
var Modal = __webpack_require__(767);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/urls.js
var urls = __webpack_require__(1510);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/cards/BlogCard.jsx
var BlogCard = __webpack_require__(505);
// EXTERNAL MODULE: ./components/loader/SimpleLoader.jsx
var SimpleLoader = __webpack_require__(8785);
;// CONCATENATED MODULE: ./pages/blogs/[id].jsx






















var Blog = function(param) {
    var blog = param.blog;
    console.log(blog.slug);
    var router = (0,next_router.useRouter)();
    var params = router.query;
    var limit = 6;
    var postUrl = "https://www.optimumwellness.in" + router.asPath;
    var ref = (0,react.useState)(null), selectedImage = ref[0], setSelectedImage = ref[1];
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,react.useState)(0), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react.useState)([]), blogs = ref3[0], setBlogs = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    (0,react.useEffect)(function() {
        var fetchBlogs = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var url, res, resBlogs;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            url = urls/* default.get_blogApi.url */.Z.get_blogApi.url + "?minimal=true&limit=7";
                            setLoading(true);
                            _ctx.next = 5;
                            return axios_default().get(encodeURI(url));
                        case 5:
                            res = _ctx.sent;
                            resBlogs = res.data.filter(function(b) {
                                if (b.slug === blog.slug) {
                                    return false;
                                } else {
                                    return true;
                                }
                            });
                            setBlogs(resBlogs.slice(0, 6));
                            setPage(1);
                            setLoading(false);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            setLoading(false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function fetchBlogs() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchBlogs();
    }, [
        blog
    ]);
    var getNextBlogs = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var url, res, resBlogs;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        url = urls/* default.get_blogApi.url */.Z.get_blogApi.url + "?minimal=true&index=" + page * limit + "&limit=" + limit;
                        setLoading(true);
                        _ctx.next = 5;
                        return axios_default().get(encodeURI(url));
                    case 5:
                        res = _ctx.sent;
                        if (page === 0) {
                            setBlogs(res.data);
                        } else {
                            resBlogs = res.data.filter(function(b) {
                                if (b.slug === blog.slug) {
                                    return false;
                                } else {
                                    return true;
                                }
                            });
                            setBlogs((0,_to_consumable_array/* default */.Z)(blogs).concat((0,_to_consumable_array/* default */.Z)(resBlogs)));
                        }
                        setPage(page + 1);
                        setLoading(false);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        setLoading(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function getNextBlogs() {
            return _ref.apply(this, arguments);
        };
    }();
    var enlargeImage = function(index) {
        setSelectedImage(index);
        setShow(true);
    };
    var resizeHandler = function() {
        var navbar = document.getElementById("navbar");
        var contents = document.getElementById("stickyContents");
        if (!navbar) return;
        if (!contents) return;
        if (window.innerWidth <= 600) {
            if (contents.parentElement.parentElement.getBoundingClientRect().top + 50 < 0) {
                navbar.style.position = "inherit";
                contents.classList.add("sticky2");
            } else {
                navbar.style.position = "fixed";
                contents.classList.remove("sticky2");
            }
        } else {
            navbar.style.position = "fixed";
            contents.classList.add("sticky3");
            contents.classList.remove("sticky2");
        }
    };
    (0,react.useEffect)(function() {
        var setProgress = function() {
            var scrollPercentRounded = Math.round(window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100);
            document.getElementById("blogContentProgress").style.width = scrollPercentRounded + "%";
        };
        window.addEventListener("scroll", setProgress);
        return function() {
            window.removeEventListener("scroll", setProgress);
            if (document.getElementById("blogContentProgress")) {
                document.getElementById("blogContentProgress").style.width = "0%";
            }
            if (!document.getElementById("navbar").classList.contains("fixed-top")) {
                document.getElementById("navbar").classList.add("fixed-top");
            }
        };
    }, [
        params
    ]);
    (0,react.useEffect)(function() {
        resizeHandler();
        window.addEventListener("scroll", resizeHandler);
        return function() {
            window.removeEventListener("scroll", resizeHandler);
        };
    }, []);
    var routeToSection = function(id) {
        var element = document.getElementById(id);
        var headerOffset = 100;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    };
    var settings = {
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    var imageName = blog.headerImage.length > 0 ? blog.headerImage[0].image.split("/")[blog.headerImage[0].image.split("/").length - 1] : "";
    var tempThumbnailName = decodeURI(imageName.split(".")[0] + "_thumbnail.jpg");
    var thumbnailName = tempThumbnailName.replace(/ /g, "_");
    if (true) {
        var imgs = document.querySelectorAll("#blogContent img");
        imgs.forEach(function(img) {
            var newDiv = document.createElement("div");
            newDiv.className = "text-center mt-5";
            newDiv.appendChild(img.cloneNode());
            img.parentElement.appendChild(newDiv);
            img.parentElement.removeChild(img);
        });
    }
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-5 main2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: blog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: blog.summary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/thumbnails/" + thumbnailName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "content-type",
                        content: "blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "800"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "391"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: blog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: blog.author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: blog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: blog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: blog.summary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: postUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "OPTIMUM WELLNESS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: blog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: blog.summary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://assets.alanvidyushbaptist.com/thumbnails/" + thumbnailName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "blogContentProgress",
                style: {
                    height: "5px",
                    position: "fixed",
                    top: "0px",
                    width: "0%",
                    background: "#7621EC",
                    zIndex: "999999"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    flex: 1
                },
                className: "mb-5 dynamicPageSection",
                children: [
                    blog && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "blogAvailable",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-1 mt-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                                    children: blog && blog.headerImage.map(function(elem, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "blogHeaderImage ".concat(index === 0 ? "active" : ""),
                                            "data-interval": blog["data_interval"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: elem["image"],
                                                alt: elem["title"],
                                                style: {
                                                    margin: "0 auto"
                                                },
                                                width: "1100",
                                                height: "500",
                                                loading: "lazy"
                                            })
                                        }, index);
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blogWriter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "blogWriter",
                                        children: blog && blog.client && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: blog.client
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_CoachSection, {
                                        coaches: blog.coach
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center fw-700 mfo-12 mt-5",
                                        id: "brands",
                                        children: blog && blog.brands && "BRANDS: ".concat(blog.brands)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blogHeading text-center mt-5",
                                id: "blogHeading",
                                children: blog && "".concat(blog.title)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "blogBorder"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fo-13 mt-5 text-center blogDate",
                                id: "blogdate",
                                children: blog && "".concat(blog.date)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blogContentContainer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row m-0 flex-sm-row-reverse",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-sm-11 p-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row m-0 flex-sm-row-reverse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-sm-4 blogContents p-0 mt-4 mt-sm-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "stickyContents sticky3",
                                                            id: "stickyContents",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_Accordian, {
                                                                title: "Contents",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "pt-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "ps-2",
                                                                        id: "contentList2",
                                                                        children: blog && blog.content.map(function(elem, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                className: "fo-16 cursorPointer",
                                                                                onClick: function() {
                                                                                    return routeToSection(elem.id);
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                                                                        icon: free_solid_svg_icons_index_es/* faCircle */.diR,
                                                                                        className: "fo-7 me-3 bco fw-600"
                                                                                    }),
                                                                                    elem["title"]
                                                                                ]
                                                                            }, index);
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-sm-8 mt-5 mt-sm-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            id: "blogContent",
                                                            children: blog && blog.body.map(function(elem, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "blogContent blogHeadContent fw-600 fo-30 mt-5 mb-2 mt-md-3 mb-md-2",
                                                                            id: "topic" + elem["id"],
                                                                            children: [
                                                                                " ",
                                                                                elem["heading"]
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "blogContent blogBodyContent fo-19 mfo-14",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: elem["paragraph"]
                                                                            }
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                                                        show: blog && show,
                                                        onHide: function() {
                                                            return setShow(false);
                                                        },
                                                        animation: true,
                                                        size: "lg",
                                                        backdrop: true,
                                                        onExited: function() {
                                                            return setSelectedImage(false);
                                                        },
                                                        centered: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                                                            as: "div",
                                                            bsPrefix: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    type: "button",
                                                                    className: "close galleryClose",
                                                                    "data-dismiss": "modal",
                                                                    onClick: function() {
                                                                        return setShow(false);
                                                                    },
                                                                    children: "\xd7"
                                                                }),
                                                                blog && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: blog.gallery[selectedImage || 0].image,
                                                                    height: "300",
                                                                    className: "w-100 h-100 copyright_img",
                                                                    alt: "image_" + blog.gallery[selectedImage || 0].title,
                                                                    loading: "lazy"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogGallery, {
                                                        children: blog && blog.gallery.map(function(image, index) {
                                                            var clickHandler = function(event) {
                                                                if (event.detail >= 2) enlargeImage(index);
                                                            };
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "p-4",
                                                                style: {
                                                                    outline: "none",
                                                                    border: "none"
                                                                },
                                                                onClick: clickHandler,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: image["image"],
                                                                    height: "300",
                                                                    style: {
                                                                        outline: "none",
                                                                        border: "none"
                                                                    },
                                                                    className: "w-100 copyright_img no-outline",
                                                                    alt: "image_" + image["title"],
                                                                    loading: "lazy"
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogShareIcons, {
                                            postTitle: blog.title,
                                            postUrl: postUrl,
                                            postSummary: blog.summary
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !blog && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        id: "blogNotAvailable",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center fw-600 fo-24 mb-4 mt-5",
                                children: "Sorry, this page isn't available."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    "The link you followed may be broken, or the page may have been removed.",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        className: "bco fw-600",
                                        children: "Go back to Home."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "textDark fo-30 mfo-22 p-3 mt-4 mt-sm-0 p-sm-5 text-center fw-700",
                children: "MORE FROM OPTIMUM WELLNESS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row m-0 mt-3 m-md-5 mt-md-3",
                children: blogs.map(function(blog, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                        blog: blog
                    }, index);
                })
            }),
            !loading && blogs && blogs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center mt-5",
                    children: limit * page <= blogs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn showMoreButton",
                        onClick: getNextBlogs,
                        children: "READ MORE"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fo-20 fw-600 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Revisit us again for more!"
                        })
                    })
                })
            }),
            !loading && blogs && blogs.length <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center",
                children: "No Blogs Found"
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleLoader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 mb-5",
                style: {
                    height: "20px"
                }
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _id_ = (Blog);


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
var baseUrl = "https://itchy-blue-seagull.cyclic.app";
// export const domainUrl = "https://optimumwellness.in";
// export const baseUrl = `http://localhost:8081`;
// http://localhost:8081
var urlSet = {
    // Blogs
    get_blogApi: {
        // Get blogs
        url: baseUrl + "/api/v1/blogs",
        method: "GET"
    },
    post_blogApi: {
        // Add a new blog
        url: baseUrl + "/api/v1/blogs/",
        method: "POST"
    },
    edit_blogApi: {
        // Edit blog
        url: baseUrl + "/api/v1/blogs/",
        method: "PATCH"
    },
    delete_blogApi: {
        // Delete a blog
        url: baseUrl + "/api/v1/blogs/",
        method: "DELETE"
    },
    get_AuthorblogApi: {
        // Get blogs of an author
        url: baseUrl + "/api/v1/blogs/author/",
        method: "GET"
    },
    get_featuredblogApi: {
        // Get featured blogs
        url: baseUrl + "/api/v1/blogs/featured",
        method: "GET"
    },
    data_intervalApi: {
        // set data interval
        url: baseUrl + "/api/v1/blogs/updateDataInterval",
        method: "PATCH"
    },
    // Admin
    adminLoginApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/login",
        method: "POST"
    },
    adminUpdateApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/update",
        method: "PATCH"
    },
    // Admin blogs
    add_blog_to_featuredApi: {
        // Add to featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "PATCH"
    },
    delete_blog_from_featuredApi: {
        // Delete from featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "DELETE"
    },
    // Admin services
    viewServicesApi: {
        // To get services
        url: baseUrl + "/api/v1/admin/service/",
        method: "GET"
    },
    getMainServiceApi: {
        // To get services based on level
        url: baseUrl + "/api/v1/admin/service",
        method: "GET"
    },
    addServiceApi: {
        // To add new service
        url: baseUrl + "/api/v1/admin/service",
        method: "POST"
    },
    deleteServiceApi: {
        // To delete services
        url: baseUrl + "/api/v1/admin/service/",
        method: "DELETE"
    },
    editServicesApi: {
        // Update service names
        url: baseUrl + "/api/v1/admin/service/",
        method: "PATCH"
    },
    // Admin offers
    editOffersApi: {
        // Update offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "PATCH"
    },
    deleteOffersApi: {
        // Delete offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "DELETE"
    },
    // Admin coupons
    viewCouponsApi: {
        // Get all coupons
        url: baseUrl + "/api/v1/admin/coupon",
        method: "GET"
    },
    addCouponsApi: {
        // Add new coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "POST"
    },
    deleteCouponsApi: {
        // Delete a coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "DELETE"
    },
    // Payments
    applyCouponApi: {
        // Apply coupon
        url: baseUrl + "/api/v1/payment/applyCoupon",
        method: "POST"
    },
    paymentApi: {
        // Create payment order id
        url: baseUrl + "/api/v1/payment/generateReceipt",
        method: "POST"
    },
    verifyPaymentApi: {
        // Verify payments status after razorpay
        url: baseUrl + "/api/v1/payment/verifyPayment",
        method: "POST"
    },
    // Admin transactions
    viewTransactionsApi: {
        // View all transactions
        url: baseUrl + "/api/v1/transaction",
        method: "GET"
    },
    addTransactionsApi: {
        // Add transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "POST"
    },
    updateTransactionsApi: {
        // Update transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "PATCH"
    },
    deleteTransactionsApi: {
        // Delete transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "DELETE"
    },
    // Add employees
    viewEmployeesApi: {
        // Get all employees
        url: baseUrl + "/api/v1/employees/?index=0&limit=50",
        method: "GET"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (urlSet);


/***/ }),

/***/ 1530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collapsibleBlogCategories":"Section_collapsibleBlogCategories__ZzpFb","topic":"Section_topic__tx44d","category":"Section_category__ifcBc","header":"Section_header__chCDA","textLeft":"Section_textLeft__Qsrpj","associations":"Section_associations__c8Klr","container-fluid":"Section_container-fluid__u8tVm","mb9":"Section_mb9__6F0FJ","collabs":"Section_collabs__xLZ_u","aboutContainer":"Section_aboutContainer___78iR","aboutQuote":"Section_aboutQuote__yKcjH","associationsContainer":"Section_associationsContainer__tXRd1","blogSlider":"Section_blogSlider__q6MgZ","blogcardimage":"Section_blogcardimage__97fur","blogBody":"Section_blogBody__QjNRF","blogsHandlerIcons":"Section_blogsHandlerIcons__ditPa","blogFooter":"Section_blogFooter__sIZcJ","mfo35":"Section_mfo35__xt2Xq","mfo32":"Section_mfo32__Jnydl","mfo30":"Section_mfo30__dIX1q","mfo25":"Section_mfo25__Ji3Gf","mfo24":"Section_mfo24__aPa4q","mfo22":"Section_mfo22__bbyKP","mfo20":"Section_mfo20__N33JU","mfo18":"Section_mfo18__28n9I","mfo17":"Section_mfo17__5bPV2","mfo16":"Section_mfo16__S1UiP","mfo15":"Section_mfo15__Y24O2","mfo14":"Section_mfo14__9GTSv","mfo13":"Section_mfo13__Svnkq","mfo12":"Section_mfo12__LTenZ","mfo11":"Section_mfo11__ijH8Y","mow90":"Section_mow90__pFbuQ","fo11":"Section_fo11__Ey_wt","fo12":"Section_fo12__PLZ8h","fo13":"Section_fo13__OjkqV","fo14":"Section_fo14__vKcce","fo15":"Section_fo15__VoZZ0","fo16":"Section_fo16__dlPMl","fo17":"Section_fo17__D4OsR","fo18":"Section_fo18__qGwOE","fo19":"Section_fo19__HwtjF","fo20":"Section_fo20__BtUTx","fo21":"Section_fo21__Mkpqk","fo22":"Section_fo22__I5xXE","fo24":"Section_fo24__62oBY","fo26":"Section_fo26__TOJOQ","fo28":"Section_fo28__hWErx","fo30":"Section_fo30__Fj7XO","fo32":"Section_fo32__1aHul","fo34":"Section_fo34__4jHU_","fo36":"Section_fo36__UdJWx","fo40":"Section_fo40__doCfb","fo52":"Section_fo52__DEguF","fo55":"Section_fo55__2v9cP","fo65":"Section_fo65__AFeJx","fw400":"Section_fw400__nHLHh","fw600":"Section_fw600__AyYCY","fw700":"Section_fw700__1aLwU","fw800":"Section_fw800__tcKE_","cursorPointer":"Section_cursorPointer__GzU7R","bco":"Section_bco__44ahG","accordion":"Section_accordion__doIWz","accordionTitle":"Section_accordionTitle__62o3s","toggle":"Section_toggle__7gqGY","accordionContent":"Section_accordionContent__MfSla","horizontalBar":"Section_horizontalBar___KXHZ","blogShareDiv":"Section_blogShareDiv__oMpnx"};

/***/ }),

/***/ 7539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listed_blog_title":"Card_listed_blog_title__A_axn","listed_blog_summary":"Card_listed_blog_summary__UyN11"};

/***/ }),

/***/ 5876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"simpleLoader":"loaders_simpleLoader__YHLAr","loader":"loaders_loader__wvx3u","loaderc":"loaders_loaderc__gH_A7","rotation":"loaders_rotation__Texb1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [217,975,774,888,179], function() { return __webpack_exec__(7895); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);